import { REHYDRATE } from 'redux-persist/lib/constants'
import { takeLatest, takeLeading, call, put, all } from 'redux-saga/effects'

import api from 'services/api'

import {
  checkWhiteLabelSuccess,
  checkWhiteLabelFailure,
  checkWhiteLabelRequest,
} from './actions'

export function* checkWhiteLabel(action) {
  if (action.key !== 'intelup@whiteLabel') return
  try {
    const file_name = window.location.host
      .split('.')
      .join('_')
      .replace(':', '_')

    const { data } = yield call(api.get, `config/${file_name}`)

    yield put(checkWhiteLabelSuccess(data))
  } catch (error) {
    yield put(checkWhiteLabelFailure('Erro ao tentar consultar o contrato'))
  }
}

export function* handleRehydrate(action) {
  if (action.key === 'intelup@whiteLabel') {
    const whiteLabelState = action.payload
    // Only fetch if data is missing or incomplete (no logo/favicon)
    if (!whiteLabelState || !whiteLabelState.logo || !whiteLabelState.favicon) {
      yield put(checkWhiteLabelRequest())
      yield* checkWhiteLabel(action)
    }
  }
}

export default all([
  takeLatest('@whiteLabel/REQUEST', checkWhiteLabel),
  takeLeading(REHYDRATE, handleRehydrate),
])
